<template>
<v-card>
<v-toolbar flat color="#273C51" height="42">
  <v-toolbar-title style="color:white">
Добавление нового поста или шаблона
  </v-toolbar-title>
<v-spacer/>
<v-icon @click="posts.modals.creator = false" color="white">mdi-close</v-icon>
</v-toolbar>

<v-card-text>

<v-text-field style="margin-bottom:10px" hide-details v-model="posts.creator.post_id" solo  clearable label="Ссылка на пост, пример wall123_12 или имя шаблона">
<v-tooltip slot="prepend-inner" top >
<span>Создать новый пост</span>
<v-icon @click="openNewPost()" slot="activator" color="green">mdi-plus</v-icon>
</v-tooltip>
</v-text-field>

<v-select style="margin-bottom:10px" hide-details   label="Выбрать задание" clearable item-value = "task_id" item-text="name"
v-model="posts.creator.task_id" :items="tasks"
>
</v-select>

<v-select :disabled="posts.creator.post_id.slice(0,4) != 'wall'" style="margin-bottom:10px" hide-details   label="Выбрать статус поста" clearable item-value = "value" item-text="title"
v-model="posts.creator.status" :items="postStatusList"
>
</v-select>



</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn @click="posts.modals.creator = false" color="#273C51" flat style="text-transform:none">Отмена</v-btn>
<v-btn @click="addPost()"   small color="#273C51" style="text-transform:none" class="white--text"> <v-icon left>mdi-plus</v-icon> Добавить пост</v-btn>
</v-card-actions>

<!-- Диалоговые окна отрытие -->
<v-dialog v-model="posts.modals.newPost" width="950" persistent scrollable>
<newPost :posts="posts"></newPost>
</v-dialog>
<!-- Диалоговые окна закрытие -->



</v-card>
</template>

<script>
import axios from 'axios'
import newPost from './newPost.vue'
export default {
props: ['posts'],
components:{newPost},

data () {
return {

postStatusList:[
    {title:'Не используется', value:"1"},
    {title:'Выбранный', value:"2"},
    {title:'Блокирован', value:"3"},
    {title:'Бловкирован в vk', value:"4"}
],
tasks:[],
disable:true
}
},
methods: {

addPost(){
this.posts.editStatus = 'create'
axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/add_posts.php', {
params:{
  params:this.posts.creator,
  editStatus:this.posts.editStatus
}
}).then(response => {
this.$router.go()

})
},

tasksData(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
method: 'POST',
data: {
contentType: 'pages'
}
})
.then( response => {
response.data.forEach(item=>{
item.actions = JSON.parse(item.actions)
if(item.actions.postActions.activated === true){this.tasks.push(item)}
})

})

},

openNewPost(){
this.posts.modals.newPost = true
},

},
computed:{
},
mounted(){
this.tasksData()
},

}
</script>

<style    >

</style>
